import {put, select} from 'redux-saga/effects'
import StartupActions from '../Redux/StartupRedux'
import {AuthSelectors} from '../Redux/AuthRedux'
import AuthApi from '../Services/AuthApi'
import {push} from 'connected-react-router'

import utils from '../Utils/utils'

const registrationPages = ['sign-up', 'restore-password', 'check-mailbox', 'expired', 'already-registered', 'verify-mailbox', 'registration-finished',]

// process STARTUP actions
export function* startup(action) {

  const userInfo = yield select(AuthSelectors.getUserInfo)
  const accessToken = yield select(AuthSelectors.getAccessToken)
  const refreshToken = yield select(AuthSelectors.getRefreshToken)
  const onBoardingFinished = yield select(AuthSelectors.getOnBoardingFinished)
  const pathname = document.location.pathname

  if (accessToken && userInfo) {
    AuthApi.updateAccessToken(accessToken, refreshToken)

    if (pathname !== '/' && (['home', 'admin', 'onboarding'].some(el => utils.includeCurrentLocation(pathname, el)))) {
      yield put(push(pathname))
    } else {
        if (userInfo.role.id === 0){
          if (onBoardingFinished) {
            yield put(push('/home/ad-library'))
          }else {
            yield put(push('/onboarding/plan'))
          }
        }
        if (userInfo.role.id === 1 || userInfo.role.id === 2) yield put(push('/admin/top-performing-products'))
    }
  } else {
    if (registrationPages.some(el => utils.includeCurrentLocation(pathname, el))) {
      yield put(push(pathname))
    } else {
      // yield put(push('/login'))
    }
  }
  yield put(StartupActions.startupSuccess())
}
